module.exports = __webpack_public_path__ + "fonts/6b52da97-62cc-435e-9602-a010041892ca.9708baec.eot";